import { CustomPDFReportsFolderableListItemComponent } from 'CustomPDFReportsApp/ts/apps/custom-pdf-reports-list-app/components/custom-pdf-reports-folderable-list-item/custom-pdf-reports-folderable-list-item.component';
// Typing
import { FolderableType } from 'FoldersApp/enums/folderable-type.enum';
export const MY_YCHARTS_ICON_CSS_CLASS_MAP = {
    analysis_plan: 'file-ia',
    comp_screen: 'file-ss',
    custom_email_report: 'file-er',
    custom_pdf_report: 'file-pdf',
    custom_security: 'file-cs',
    dashboard: 'file-db',
    fund_screen: 'file-fs',
    hypothetical: 'file-s',
    metric_set: '',
    model_portfolio: 'file-p',
    portfolio_optimizer: 'file-po',
    registration: 'file-r',
    risk_profile: 'file-rp',
    saved_comp_table: 'file-ct',
    saved_fundamental_chart: 'file-fc',
    saved_score: '',
    saved_timeseries_table: 'file-ts',
    scatter_plot: 'file-sp',
    stress_test: '',
    tech_chart: 'file-tc',
    user_talking_point: 'file-tp',
    watchlist: 'file-wl',
};
export const MY_YCHARTS_FILE_ABBR_MAP = {
    analysis_plan: 'ia',
    comp_screen: 'ss',
    custom_email_report: 'er',
    custom_pdf_report: 'pdf',
    custom_security: 'cs',
    dashboard: 'db',
    fund_screen: 'fs',
    hypothetical: 's',
    metric_set: '',
    model_portfolio: 'p',
    portfolio_optimizer: 'po',
    registration: 'r',
    risk_profile: 'rp',
    saved_comp_table: 'ct',
    saved_fundamental_chart: 'fc',
    saved_score: '',
    saved_timeseries_table: 'ts',
    scatter_plot: 'sp',
    stress_test: '',
    tech_chart: 'tc',
    user_talking_point: 'tp',
    watchlist: 'wl',
};
/**
 * Mapping of folderable resource types to their corresponding list item components.
 */
export const MY_YCHARTS_FOLDERABLE_LIST_ITEM_MAP = {
    [FolderableType.CUSTOM_PDF_REPORT]: CustomPDFReportsFolderableListItemComponent,
};
/**
 * List of folderable types that should override `MyYChartsFolderableListItem` dropdown configuration and app
 * specific operation handling.
 */
export const MY_YCHARTS_FOLDERABLE_LIST_ITEM_OVERRIDES = new Set([FolderableType.CUSTOM_PDF_REPORT]);
import { FolderableAppType } from 'FoldersApp/enums/folderable-app-type.enum';
export const MY_YCHARTS_FOLDERABLE_APP_CONFIG = {
    appName: 'MyYChartsApp',
    folderableAppType: FolderableAppType.LIST_PAGE,
    itemNamePlural: 'My YCharts',
};
